import { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useBaasInstance } from "../../../../Contexts/BaasInstanceContext";
import { useBaasPlatformCreateAccess } from "../../../../Hooks/useBaasPlatformCreateAccess";
import {
  isBaasKybPending,
  isBaasProdAwaitingLiberation,
} from "../../../../Services/baasInstancesApi";
import {
  isBaasAdminPath,
  isBaasInstanceUsersPath,
  isBaasOnboardPath,
  isBaasOrgUsersGroupsPath,
} from "../constants";

/** Redirects to instances picker when no environment is selected (console routes only). */
export const BaasConsoleRoute = ({ children }) => {
  const location = useLocation();
  const {
    selectedInstance,
    selectedInstanceId,
    listInstanceFilter,
    dataEpoch,
    clearSelectedInstance,
  } = useBaasInstance();
  const { canUseViewAs, loading: accessLoading } = useBaasPlatformCreateAccess();
  const isAdminRoute = isBaasAdminPath(location.pathname);
  const isOrgUsersGroups = isBaasOrgUsersGroupsPath(location.pathname);
  const isInstanceUsers = isBaasInstanceUsersPath(location.pathname);
  const isOnboard = isBaasOnboardPath(location.pathname);

  // Soft bounce: partner landed on Prod awaiting liberação (deep link / sticky) → picker.
  const partnerBlockedOnAwaitingProd =
    !accessLoading &&
    Boolean(selectedInstance) &&
    isBaasProdAwaitingLiberation(selectedInstance) &&
    !canUseViewAs;

  useEffect(() => {
    if (!partnerBlockedOnAwaitingProd) return;
    clearSelectedInstance();
  }, [partnerBlockedOnAwaitingProd, clearSelectedInstance]);

  if (partnerBlockedOnAwaitingProd) {
    return <Redirect to="/baas" />;
  }

  if ((isInstanceUsers || isOnboard) && !selectedInstance) {
    return <Redirect to="/baas" />;
  }

  if (!selectedInstance && !isAdminRoute) {
    return <Redirect to="/baas" />;
  }

  // Org users/groups inherit membership — never block on instance KYB.
  if (
    selectedInstance &&
    !isOrgUsersGroups &&
    isBaasKybPending(selectedInstance) &&
    location.pathname !== "/baas/kyb"
  ) {
    return <Redirect to="/baas/kyb" />;
  }

  // Remount console pages on instance switch so lists/local state cannot leak
  // across VALUT-SAUDE ↔ other cards.
  const scopeKey = selectedInstance
    ? `${selectedInstanceId || selectedInstance.id}:${listInstanceFilter || "valut"}:${dataEpoch}`
    : `admin:${dataEpoch}`;

  return <div key={scopeKey} className="baas-console-scope min-w-0">{children}</div>;
};
